import { CButton, CCol, CContainer, CFormLabel, CFormTextarea, CModal, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow, CTooltip } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import Graytextarea from '../../components/Graytextarea'
import SaveExtra from '../../services/general/saveExtraData.api'
import { Info, Plus } from 'lucide-react'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

import { CFormCheck } from '@coreui/react'
import AddOrders from './AddOrders'
import { readOnlyMode } from '@syncfusion/ej2-richtexteditor'
import BulletTextArea from '../../components/BulletTextArea'

const AssessmentFinalNote = ({
  diagnosisName,
  saveTreatsShell,
  patientID,
  contentEditable = false,
  isTextInput,
  isAllotedToProvider,
  showDataIfNoteIsFollowUp = true,
  showTreatmentAsAccordion,
  patientTreatments,
  noteStructureRef,
  imagingTypeList,
  imaging,
  MasterDiagnosisData,
  medsRemarks,
  allLabs,
  diagnosisAddedPinger,
  medicationList,
  masterMedications,
  noteID,
}) => {
  const [visible, setVisible] = useState(false)
  const [assessment, setAssessment] = useState('')
  const [freeType, setFreeType] = useState('')
  const [poa, setPoa] = useState('')
  const [assessmentSuggestions, setAssessmentSuggestions] = useState('')
  const [bimsScoreData, setBimsScoreData] = useState({
    score: '',
    date: '',
  })
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [activeKey, setActiveKey] = useState(1)
  const [activeKey2, setActiveKey2] = useState(1)
  const [sugesstionsAssessmentsList, setSugesstionsAssessmentsList] = useState([]) //putting the fetched data

  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  const [showAssessmentEditHtml, setShowAssessmentEditHtml] = useState(false)
  const [tempAssessmentHtmlContent, setTempAssessmentHtmlContent] = useState('')

  const [assessmentFinalValue, setAssessmentFinalValue] = useState('')

  const [selectedAssessmentSuggestionStrings, setSelectedAssessmentSuggestionString] = useState([])
  const [selectedPlansSuggestionsStrings, setSelectedPlanSuggestionsStrings] = useState([])
  const [selectedPlanSuggestion, setSelectedPlanSuggestion] = useState([])
  let count = 0
  let newAssessment = ''

  useEffect(() => {
    if (noteStructureRef && noteStructureRef.current && noteStructureRef.current?.BIMSScore) {
      const bimsForCognitive = noteStructureRef?.current?.BIMSScore['Cognitive Communication Deficit']
      setBimsScoreData(bimsForCognitive)
    }
  }, [])

  useEffect(() => {
    if (patientTreatments && patientTreatments.length > 0) {
      let treatmentDetails = patientTreatments[noteID || 0]
      if (!treatmentDetails) {
        treatmentDetails = patientTreatments[0]
      }
      const { data } = treatmentDetails
      if (!noteStructureRef.current?.assessment) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          assessment: {
            ...noteStructureRef.current.assessment,
            [diagnosisName]: {
              MobilityAssessment: {},
              POA: '',
              MorseScore: {},
              LabImaging: '',
              FreeType: '',
              assessmentSuggestions: '',
              selfCareAssessment: {},
            },
          },
        }
      } else if (noteStructureRef.current?.assessment && !noteStructureRef.current?.assessment[diagnosisName]) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          assessment: {
            ...noteStructureRef.current.assessment,
            [diagnosisName]: {
              MobilityAssessment: {},
              POA: '',
              MorseScore: {},
              LabImaging: '',
              FreeType: '',
              selfCareAssessment: {},
            },
          },
        }
      } else if (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]) {
        if (typeof data?.assessment?.[diagnosisName] === 'string') {
          noteStructureRef.current = {
            ...noteStructureRef.current,
            assessment: {
              ...noteStructureRef.current.assessment,
              [diagnosisName]: {
                MobilityAssessment: {},
                POA: '',
                MorseScore: {},
                LabImaging: '',
                FreeType: '',
                selfCareAssessment: {},
              },
            },
          }
        }
      }
      let existingAssessment = `${noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.LabImaging} ` || ''
      // const existingAssessment = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]) || "";

      if (existingAssessment.trim() === 'undefined' || existingAssessment === 'null') {
        existingAssessment = ''
      }
      let freeTypeData = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.FreeType) || ''
      let assessmentSuggestions = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.assessmentSuggestions) || ''
      // if (diagnosisName !== 'Falls') {
      //     existingAssessment = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]) || "";

      // } else {
      //     existingAssessment = (noteStructureRef.current?.assessment && noteStructureRef.current?.assessment[diagnosisName]?.LabImaging) || "";
      // }
      setAssessmentSuggestions(assessmentSuggestions)
      setFreeType(freeTypeData)
      setTempFreeType(freeTypeData)
      // newAssessment = existingAssessment || "";
    } else {
      noteStructureRef.current = {
        ...noteStructureRef.current,
        assessment: {
          ...noteStructureRef.current.assessment,
          [diagnosisName]: {
            MobilityAssessment: {},
            POA: '',
            MorseScore: {},
            LabImaging: '',
            FreeType: '',
            selfCareAssessment: {},
          },
        },
      }
    }

    let allImagingRemarks = null

    let lastLabsRemarks = []

    let standingMedicationTemplate = ''

    let lastImaging = imaging && imaging.length > 0 && imaging[imaging.length - 1]

    if (imagingTypeList.length > 0 && lastImaging?.data) {
      const lastImagingImpression = lastImaging.data.impression.toLowerCase()
      const lastImagingPatientSelectedImaging = lastImaging.data.name.toLowerCase()

      const findMatchingImagingMaster = imagingTypeList.find((item) => item.Name.toLowerCase() === lastImagingPatientSelectedImaging)

      if (findMatchingImagingMaster) {
        let matchingDiagnosisImaging = []
        for (let keywordDetail of findMatchingImagingMaster.Keywords) {
          if (!keywordDetail?.keyword) return
          const keywordsArray = keywordDetail.keyword
            .split(',')
            .map((keyword) => keyword.trim().toLowerCase())
            .filter((keyword) => keyword !== '')
          if (keywordsArray.some((item) => lastImagingImpression.includes(item?.toLowerCase()))) {
            matchingDiagnosisImaging.push(keywordDetail)
          }
        }
        for (const remarkD of matchingDiagnosisImaging) {
          for (const masterD of MasterDiagnosisData) {
            if (masterD.id === Number(remarkD.diagnosis)) {
              if (diagnosisName.trim() === masterD.Name.trim()) {
                allImagingRemarks = [
                  {
                    ...masterD,
                    ...remarkD,
                    ...lastImaging,
                  },
                ]
              }
            }
          }
        }
      }
    }

    if (allLabs.length > 0) {
      const lastLab = allLabs[0] || []

      const lastLabArrOfLabs = lastLab?.data || []

      let allMatchingLab = lastLabArrOfLabs.filter((item) => {
        const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
        return diagnosisLab.some((diagn) => diagn.includes(diagnosisName))
      })

      lastLabsRemarks = allMatchingLab.map((item) => item.remark).filter((item) => item !== '')
    }

    if (lastLabsRemarks.length > 0) {
      const lastLabsRemarksText = lastLabsRemarks.join('\n')

      if (!newAssessment.includes(lastLabsRemarksText)) {
        if (newAssessment !== '') {
          newAssessment += '\n'
        }
        newAssessment += lastLabsRemarksText
      }
    }

    if (allImagingRemarks) {
      if (!newAssessment.includes(allImagingRemarks[allImagingRemarks.length - 1]?.remarks)) {
        if (newAssessment !== '') {
          newAssessment += '\n'
        }
        newAssessment += allImagingRemarks[allImagingRemarks.length - 1]?.remarks //tunr this off letter
      }

      // newAssessment += allImagingRemarks?.remarks; // turn this on
    }

    // if (standingMedicationTemplate && standingMedicationTemplate !== '') {
    //     if (newAssessment !== '') {
    //         newAssessment += '\n\n';
    //     }
    //     newAssessment += standingMedicationTemplate;
    // }

    // if (newAssessment.trim() !== '') {
    //     const existingAssessment = noteStructureRef.current.assessment?.[diagnosisName];

    //     if (existingAssessment !== newAssessment) {

    //         setAssessment(newAssessment);

    //         noteStructureRef.current = {
    //             ...noteStructureRef.current,
    //             assessment: {
    //                 ...noteStructureRef.current.assessment,
    //                 [diagnosisName]: newAssessment,
    //             },
    //         };
    //     } else {
    //         console.log("Duplicate assessment not added");
    //     }
    // }

    // if (newAssessment.trim !== '') {
    //     setAssessment(newAssessment);
    //     noteStructureRef.current = {
    //         ...noteStructureRef.current,
    //         assessment: {
    //             ...noteStructureRef.current.assessment,
    //             [diagnosisName]: {
    //                 ...noteStructureRef.current.assessment[diagnosisName] || {
    //                     MobilityAssessment: {},
    //                     POA: "",
    //                     MorseScore: {},
    //                     LabImaging: "",
    //                     FreeType: "",
    //                 },
    //                 LabImaging: newAssessment || '',
    //             }
    //         }
    //     }
    // }

    if (newAssessment.trim() !== '' && newAssessment.trim() !== 'undefined' && newAssessment !== 'null') {
      setAssessment(newAssessment)

      const currentAssessment = noteStructureRef.current.assessment || {}
      const existingDiagnosisData = currentAssessment[diagnosisName] || {
        MobilityAssessment: {},
        POA: '',
        MorseScore: {},
        LabImaging: '',
        FreeType: '',
      }

      noteStructureRef.current = {
        ...noteStructureRef.current,
        assessment: {
          ...currentAssessment,
          [diagnosisName]: {
            ...existingDiagnosisData,
            LabImaging: newAssessment || '',
          },
        },
      }
    }
    // setAssessment(newAssessment);
    // noteStructureRef.current = {
    //     ...noteStructureRef.current,
    //     assessment: {
    //         ...noteStructureRef.current.assessment,
    //         [diagnosisName]: {
    //             ...noteStructureRef.current.assessment[diagnosisName],
    //             LabImaging: newAssessment || '',
    //         }
    //     }
    // };
  }, [imaging, imagingTypeList, diagnosisAddedPinger, allLabs, noteStructureRef])

  // Freetype center
  const [tempFreeType, setTempFreeType] = useState('')
  const [visibleModalTempFreeType, setVisibleModalTempFreeType] = useState(false)
  // const handleFreeTypeChanges = async(value) => {
  //     setFreeType(value);
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 FreeType: value
  //             }
  //         }
  //     };
  //     // await saveTreatsShell(false)
  // }
  const handleSaveFreetype = async () => {
    setVisibleModalTempFreeType(false)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          FreeType: tempFreeType,
        },
      },
    }
    setFreeType(tempFreeType)
    await saveTreatsShell(false)
  }
  // Freetype center
  // const handleChanges = async(e) => {
  //     const { value } = e.target;
  //     setFreeType(value);
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 FreeType: value || '',
  //             }
  //         }
  //     };
  //     // await saveTreatsShell(false)
  // };

  const handlePoaChange = (value) => {
    setPoa(value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          POA: value,
        },
      },
    }
  }

  const handleLabsChanges = (value) => {
    setAssessment(value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          LabImaging: value,
        },
      },
    }
  }

  // useEffect(() => {
  //     if (!noteStructureRef.current.assessment) {
  //         noteStructureRef.current.assessment = {};
  //     }

  //     if (!noteStructureRef.current.assessment[diagnosisName]) {
  //         noteStructureRef.current.assessment[diagnosisName] = {};
  //     }

  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         assessment: {
  //             ...noteStructureRef.current.assessment,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.assessment[diagnosisName],
  //                 assessmentSuggestions: assessmentSuggestions,
  //             },
  //         },
  //     };
  // }, [assessmentSuggestions]);

  // useEffect(()=>{
  //     // planSuggestion
  //     const assessmentSuggestionAdded = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions
  //     const planSuggestionAdded = noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion;
  //     if(assessmentSuggestionAdded){
  //         const splittedArrayAssessmentSuggestion = assessmentSuggestionAdded.split('\n');
  //         if(splittedArrayAssessmentSuggestion.length > 0){

  //         }
  //         setSelectedAssessmentSuggestionString(splittedArrayAssessmentSuggestion)
  //     }
  //     if(planSuggestionAdded){
  //         const splittedArrayPlan = planSuggestionAdded.split('\n');
  //         setSelectedPlanSuggestionsStrings(splittedArrayPlan)
  //     }
  // },[])
  useEffect(() => {
    const assessmentSuggestionAdded = noteStructureRef?.current?.assessment?.[diagnosisName]?.assessmentSuggestions
    const planSuggestionAdded = noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion

    if (assessmentSuggestionAdded) {
      const splittedArrayAssessmentSuggestion = assessmentSuggestionAdded.split('\n').filter(Boolean)

      if (splittedArrayAssessmentSuggestion.length > 0) {
        setSelectedAssessmentSuggestionString(splittedArrayAssessmentSuggestion)

        // Recursively search and collect matching plan structures
        const collectedPlanSuggestions = []

        const searchAccordions = (accordions) => {
          for (const accordion of accordions) {
            const suggestions = accordion?.suggestions?.suggestionName || []

            for (const suggestion of suggestions) {
              if (splittedArrayAssessmentSuggestion.includes(suggestion.name)) {
                const planSuggestions = accordion?.suggestions?.planSuggestions || []

                const matchingPlan = planSuggestions.find((plan) => plan.name === suggestion.name)

                const flatSuggestionNames = matchingPlan?.accordions?.flatMap((acc) => acc?.suggestions?.suggestionName || []) || []

                const itemStructure = {
                  name: suggestion.name,
                  suggestions: flatSuggestionNames,
                }

                collectedPlanSuggestions.push(itemStructure)
              }
            }

            // Recurse children
            if (accordion.children && accordion.children.length > 0) {
              searchAccordions(accordion.children)
            }
          }
        }

        searchAccordions(sugesstionsAssessmentsList || [])
        setSelectedPlanSuggestion(collectedPlanSuggestions)
      }
    }

    if (planSuggestionAdded) {
      const splittedArrayPlan = planSuggestionAdded.split('\n').filter(Boolean)
      setSelectedPlanSuggestionsStrings(splittedArrayPlan)
    }
  }, [noteStructureRef.current, sugesstionsAssessmentsList])

  const getAllDiagnosisDifferential = async () => {
    let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
    data = JSON.parse(data.d)?.Data || []

    if (data) {
      data = data.map((item) => ({
        Id: item.Id,
        Data: JSON.parse(item?.JsonData),
      }))
    }

    const findAssessmentSuggestionForDiagnosis = data.find((item) => item?.Data?.diagnosis?.label === diagnosisName)
    setSugesstionsAssessmentsList(findAssessmentSuggestionForDiagnosis?.Data?.accordions)
  }

  useEffect(() => {
    getAllDiagnosisDifferential()
  }, [])

  const renderNestedAccordions = (accordions) => {
    return (
      <CAccordion>
        {accordions
          .filter((accordion) => accordion.title)
          .map((accordion, index) => {
            return (
              <CAccordionItem itemKey={accordion.id || index} key={accordion.id || index}>
                <CAccordionHeader>
                  <div className="gap-2 d-flex align-items-center">
                    {accordion?.description && accordion?.description !== '' && (
                      <CTooltip content={accordion?.description ? accordion?.description : 'Add the tooltip'}>
                        <Info strokeWidth={1} size={16} />
                      </CTooltip>
                    )}
                    {accordion.title}
                  </div>
                </CAccordionHeader>
                <CAccordionBody>
                  {accordion.children && accordion.children.length > 0 ? (
                    renderNestedAccordions(accordion.children)
                  ) : (
                    <>
                      {accordion.suggestions?.suggestionName?.map((item, idx) => {
                        return (
                          <div className="d-flex align-items-center gap-2 justify-content-between">
                            <CFormCheck
                              checked={selectedAssessmentSuggestionStrings.includes(item.name)}
                              onChange={(e) => {
                                const isAlreadySelected = selectedAssessmentSuggestionStrings.includes(item.name)

                                if (isAlreadySelected) {
                                  // Remove from all three states
                                  setSelectedAssessmentSuggestionString((prev) => prev.filter((s) => s !== item.name))
                                  setSelectedPlanSuggestion((prev) => prev.filter((s) => s.name !== item.name))
                                } else {
                                  // Add to selectedAssessmentSuggestion
                                  setSelectedAssessmentSuggestionString((prev) => [...prev, item.name])

                                  // Extract plan suggestions
                                  const planSuggestions = accordion?.suggestions?.planSuggestions

                                  const matchingPlan = planSuggestions?.find((plan) => plan.name === item?.name)

                                  const flatSuggestionNames = matchingPlan?.accordions?.flatMap((acc) => acc?.suggestions?.suggestionName || []) || []

                                  const itemStructure = {
                                    name: item?.name,
                                    suggestions: flatSuggestionNames,
                                    description: item?.description || '',
                                  }

                                  setSelectedPlanSuggestion((prev) => [...prev, itemStructure])
                                }
                              }}
                              key={idx}
                              id={`suggestion-${accordion.id}-${idx}`}
                              label={item.name}
                            />
                          </div>
                        )
                      })}
                    </>
                  )}
                </CAccordionBody>
              </CAccordionItem>
            )
          })}
      </CAccordion>
    )
  }

  const renderAccordions = () => {
    if (sugesstionsAssessmentsList?.length) {
      return renderNestedAccordions(sugesstionsAssessmentsList)
    }
    return null
  }

  useEffect(() => {
    setAssessmentFinalValue(selectedAssessmentSuggestionStrings.join('\n'))
  }, [selectedAssessmentSuggestionStrings])

  const handleSubmitModal = () => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      assessment: {
        ...noteStructureRef.current.assessment,
        [diagnosisName]: {
          ...noteStructureRef.current.assessment[diagnosisName],
          assessmentSuggestions: assessmentFinalValue,
        },
      },
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans[diagnosisName],
          planSuggestion: selectedPlansSuggestionsStrings.join('\n'),
        },
      },
    }
    setAssessmentSuggestions(assessmentFinalValue)
    setVisible(false)
  }

  const labHtml =
  noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging;

// function to check if HTML has real content
const hasValidContent = (html) => {
  if (!html) return false;

  const temp = document.createElement('div');
  temp.innerHTML = html;

  return temp.textContent.trim().length > 0;
};
  return (
    <>
      {showTreatmentAsAccordion ? (
        <div>
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />

          {isTextInput ? (
            <div>
              {poa && (
                <p>
                  <strong className="text-dark fw-semibold">POA</strong>: {poa}
                </p>
              )}
              {assessment && (
                <p>
                  {' '}
                  <strong className="text-dark fw-semibold">Assessment</strong>: {assessment}
                </p>
              )}
              {freeType && (
                <p>
                  <strong className="text-dark fw-semibold">Free Type</strong>: {freeType}
                </p>
              )}
            </div>
          ) : (
            <div className="px-2">
              {assessment && (
                <div className="mb-4">
                  <label className="text-dark fw-semibold d-block" style={{ fontSize: '14px', marginBottom: '8px' }}>
                    Labs & Imaging
                  </label>

                  <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                    {assessment}
                  </div>
                </div>
              )}
              {assessmentSuggestions && (
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-1" style={{ marginBottom: '8px' }}>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Assessment Suggestions
                    </label>
                  </div>

                  <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                    {assessmentSuggestions}
                  </div>
                </div>
              )}

              {freeType && (
                <div>
                  <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                    Free Type
                  </label>

                  <div className=" mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                    {freeType}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className="d-flex align-items-center gap-1">
            <h7>
              <b>Assessment</b>
            </h7>
          </div>
          <hr />

          {isTextInput ? (
            <div>
              {poa && (
                <p>
                  <strong className="text-dark fw-semibold">POA</strong>: {poa}
                </p>
              )}
              {assessment && (
                <p>
                  {' '}
                  <strong className="text-dark fw-semibold">Assessment</strong>: {assessment}
                </p>
              )}
              {freeType && (
                <p>
                  <strong className="text-dark fw-semibold">Free Type</strong>: {freeType}
                </p>
              )}
            </div>
          ) : (
            <div className="px-2">
              {/* <div className="mb-4">
                         <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>POA</label>
                         <CFormTextarea
                             className="bg-secondary border rounded shadow-sm mt-2"
                             rows={3}
                             value={poa}
                             onChange={(e) => { handlePoaChange(e.target.value) }}
                         />
                     </div> */}

              {
                <div className="mb-4">
                  <label className="text-dark fw-semibold d-block" style={{ fontSize: '14px', marginBottom: '8px' }}>
                    Labs & Imaging
                  </label>
                  {/* {console.log("noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging",noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging)} */}

                  {/* {noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging && (
                    <div className="my-2">
                          <div
                            className="p-2"
                            style={{
                              background: '#f5f5f5',
                              borderRadius: '10px',
                              border: '1px solid #dee2e6',
                              color: '#6c757d',
                              cursor: 'not-allowed',
                              pointerEvents: 'none',
                              opacity: 0.8,
                              // userSelect: 'none' // optional if you want to prevent selection
                            }}
                            dangerouslySetInnerHTML={{
                              __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.LabImaging
                            }}
                          ></div>
                    </div>
                  )} */}

                      {hasValidContent(labHtml) && (
                        <div className="my-2">
                          <div
                            className="p-2"
                            style={{
                              background: '#f5f5f5',
                              borderRadius: '10px',
                              border: '1px solid #dee2e6',
                              color: '#6c757d',
                              cursor: 'not-allowed',
                              pointerEvents: 'none',
                              opacity: 0.8,
                            }}
                            dangerouslySetInnerHTML={{ __html: labHtml }}
                          ></div>
                        </div>
                      )}
                  <Graytextarea height="20px" value={assessment} onChange={(e) => handleLabsChanges(e.target.value)} />
                </div>
              }
              {
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-1" style={{ marginBottom: '8px' }}>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Assessment Suggestions
                    </label>

                    {isAllotedToProvider && (
                      <CFormLabel
                        className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                        onClick={() => setVisible((p) => !p)}
                        style={{
                          width: '30px',
                          height: '30px',
                          borderRadius: '20px',
                          background: 'var(--ui-color-primary, #2b7cd3)',
                          cursor: 'pointer',
                        }}
                      >
                        <Plus className="text-white" strokeWidth={2} size={15} />
                      </CFormLabel>
                    )}
                  </div>
                  {noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions && (
                    <div className="my-2">
                      {/* <div
                        onClick={() => {
                          setTempAssessmentHtmlContent(noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions)
                          setShowAssessmentEditHtml(true)
                        }}
                        className="p-4"
                        style={{ background: '#f6f6f6ff', borderRadius: '10px', cursor: 'pointer' }}
                        dangerouslySetInnerHTML={{
                          __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions,
                        }}
                      ></div> */}
                          <div
                            className="py-2"
                            style={{
                              background: '#f5f5f5',
                              borderRadius: '10px',
                              border: '1px solid #dee2e6',
                              color: '#6c757d',
                              cursor: 'not-allowed',
                              pointerEvents: 'none',
                              opacity: 0.8,

                            }}
                            dangerouslySetInnerHTML={{
                              __html: noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosisName]?.assessmentSuggestions,
                            }}
                          ></div>
                    </div>
                  )}
                  <Graytextarea
                    height="20px"
                    // className="bg-secondary border rounded shadow-sm mt-2"
                    // rows={5}
                    value={assessmentSuggestions}
                    // onChange={(e) => handleLabsChanges(e.target.value)}
                  />
                </div>
              }
              {/* {diagnosisName === 'Cognitive Communication Deficit' && bimsScoreData && bimsScoreData.date && bimsScoreData.score && <div className="mb-4">
                         <label className="text-dark fw-semibold" style={{ fontSize: "14px" }}>Bims Score</label>
                         <CFormTextarea
                             className="bg-secondary border rounded shadow-sm mt-2"
                             rows={3}
                             disabled
                             value={bimsScoreData && bimsScoreData.date && bimsScoreData.score && `Bims Score: ${bimsScoreData.score}   recorded on Date: ${new Date(bimsScoreData.date).toLocaleDateString('en-US')}`}
                         />
                     </div>} */}
              <div>
                <label className="text-dark fw-semibold d-block" style={{ fontSize: '14px', marginBottom: '8px' }}>
                  Free Type
                </label>
                {/* <Graytextarea
                  height="20px"
                  value={freeType}
                  onChange={() => {
                    return
                  }}
                  onClick={() => {
                    setVisibleModalTempFreeType((p) => !p)
                  }}
                  rows={5}
                /> */}
                    <div
                      onClick={() => {
                        setVisibleModalTempFreeType((p) => !p)

                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {/* <BulletTextArea
                        value={freeType}
                        readOnly
                        height="60px"
                        style={{ pointerEvents: 'none' }}
                      /> */}
                       <BulletTextArea
                                          
                                          onChange={() => {
                                            return
                                          }}
                                          className="w-100"
                                          height={'20px'}
                                          value={freeType}
                                        />
                                      
                    </div>
              </div>
            </div>
          )}
        </div>
      )}

      <CModal className="modal-assessment" visible={visible} onClose={() => setVisible(false)} aria-labelledby="ToggleBetweenModalsExample1">
        <CModalBody>
          <CNav className="d-flex align-items-center gap-2" variant="pills">
            <CNavItem className="">
              <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)} style={{ cursor: 'pointer' }}>
                Suggestion
              </CNavLink>
            </CNavItem>
            <CNavItem className="">
              <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)} style={{ cursor: 'pointer' }}>
                Assessment
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey === 1}>
              <CContainer className="p-0 border m-0">
                <CRow>
                  <CCol
                    style={{
                      width: '50%',
                      overflowY: 'scroll',
                      height: '80vh',
                      borderRight: '1px solid #e2e2e2',
                    }}
                    className="w-50 p-4"
                  >
                    <div>{/* {renderAccordions()} */}</div>
                  </CCol>

                  <CCol
                    style={{
                      width: '50%',
                      overflowY: 'scroll',
                      height: '80vh',
                    }}
                    className="w-50"
                  >
                    <p className="text-center p-2 fw-bold">Add to plan</p>
                    <div className="d-flex align-items-center gap-2">
                      <CButton
                        onClick={() => {
                          setActiveKey2(1)
                          setOrderModalVisible(true)
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        Orders
                      </CButton>
                      <CButton active={activeKey2 === 2} onClick={() => setActiveKey2(2)} style={{ cursor: 'pointer' }}>
                        Suggestions
                      </CButton>
                    </div>
                    {/* <CNav className='d-flex align-items-center gap-2' variant="pills" >
                                            <CNavItem className=''>
                                                <CNavLink
                                                    
                                                >
                                                    <CButton>
                                                        Orders
                                                    </CButton>
                                                </CNavLink>
                                            </CNavItem>
                                            <CNavItem className=''>
                                                <CNavLink
                                                    
                                                >
                                                    Suggestions
                                                </CNavLink>
                                            </CNavItem>
                                        </CNav> */}

                    <CTabContent>
                      <CTabPane role="tabpanel" aria-labelledby="home-tab" className="mt-2" visible={activeKey2 === 2}>
                        <div>
                          {selectedPlanSuggestion.map((item, idx) => {
                            return (
                              <CAccordion flush>
                                <CAccordionItem itemKey={1}>
                                  <CAccordionHeader className="" style={{ fontSize: '10px' }}>
                                    <div className="d-flex align-items-center gap-2">
                                      {item?.description && item?.description !== '' && (
                                        <CTooltip content={item?.description ? item?.description : 'Add the tooltip'}>
                                          <Info strokeWidth={1} size={16} />
                                        </CTooltip>
                                      )}
                                      {item.name}
                                    </div>
                                  </CAccordionHeader>
                                  <CAccordionBody>
                                    <div>
                                      {item.suggestions.length > 0 &&
                                        item.suggestions &&
                                        item.suggestions.map((listItem, idx) => {
                                          return (
                                            <CFormCheck
                                              onChange={() => {
                                                if (selectedPlansSuggestionsStrings.length > 0 && selectedPlansSuggestionsStrings.includes(listItem.name)) {
                                                  setSelectedPlanSuggestionsStrings((prev) => prev.filter((s) => s !== listItem.name))
                                                } else {
                                                  setSelectedPlanSuggestionsStrings((prev) => [...prev, listItem.name])
                                                }
                                              }}
                                              id={listItem.name}
                                              checked={selectedPlansSuggestionsStrings.length > 0 && selectedPlansSuggestionsStrings.includes(listItem.name)}
                                              label={listItem?.name}
                                            />
                                          )
                                        })}
                                    </div>
                                  </CAccordionBody>
                                </CAccordionItem>
                              </CAccordion>
                            )
                          })}
                        </div>
                      </CTabPane>
                    </CTabContent>
                  </CCol>
                </CRow>
              </CContainer>
            </CTabPane>
            <CTabPane role="tabpanel" aria-labelledby="profile-tab" visible={activeKey === 2}>
              <Graytextarea onChange={(e) => setAssessmentFinalValue(e.target.value)} value={assessmentFinalValue} />
            </CTabPane>
          </CTabContent>
        </CModalBody>
        <CModalFooter>
          <CButton
            onClick={() => {
              setVisible(false)
              setSelectedPlanSuggestion([])
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton
            onClick={() => {
              setSelectedPlanSuggestion([])
              setSelectedAssessmentSuggestionString([])
              setAssessmentFinalValue('')
              setSelectedPlanSuggestionsStrings([])
            }}
            color="secondary"
          >
            Clear All
          </CButton>
          <CButton color="primary" className="ui-action-btn ui-action-btn--primary" onClick={handleSubmitModal}>
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <AddOrders
          patientID={patientID}
          noteID={noteID}
          diagnosisName={diagnosisName}
          toggleModal={() => {
            setOrderModalVisible((p) => !p)
            setActiveKey2(1)
          }}
          fetchOrdersAgain={() => {}}
        />
      </CModal>

      {/* freetype modal */}
      <CModal
        className="patient-theme-modal patient-note-form-modal assessment-theme__modal"
        backdrop="static"
        visible={visibleModalTempFreeType}
        onClose={() => setVisibleModalTempFreeType(false)}
        aria-labelledby="LiveDemoExampleLabel"
      >
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Add Assessment Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <BulletTextArea
            placeholder="Enter freetype"
            value={tempFreeType}
            rows={10}
            onChange={(e) => setTempFreeType(e.target.value)}
            style={{
              minHeight: '320px',
              border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)',
              background: 'var(--ui-bg-inset, #1b1b1b)',
              color: 'var(--ui-text-primary, #ffffff)',
            }}
          />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisibleModalTempFreeType(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSaveFreetype}>
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Labs & Imaging Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  assessments: {
                    ...noteStructureRef.current?.freeTypesEverything?.assessments,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.assessments?.[diagnosisName],
                      LabImaging: tempHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showAssessmentEditHtml} onClose={() => setShowAssessmentEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Assessment Suggestions Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempAssessmentHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempAssessmentHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowAssessmentEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  assessments: {
                    ...noteStructureRef.current?.freeTypesEverything?.assessments,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.assessments?.[diagnosisName],
                      assessmentSuggestions: tempAssessmentHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowAssessmentEditHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AssessmentFinalNote
